"use strict";

//const url = 'https://cleancutmeals.sitepreview.app';
const url = 'https://cleancutmeals.ie';
//const url = 'https://' + document.domain;
const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjEsIm5hbWUiOiJ3cGRldiIsImlhdCI6MTY4Njk0ODgzNiwiZXhwIjoxODQ0NjI4ODM2fQ.eP-oBMXKS6FBB55L6xbPANZL4OpVbz6RHdkIc9wMI_8";

export { url, token };